import VoltageLimits, { connector } from './VoltageLimits';

export default connector(VoltageLimits);
